import './styles/Logo.scss';

import { ImgHTMLAttributes } from 'react';

import ErrorLoadingImage from 'assets/errorLoadingImage.png';
import Placeholder from 'assets/placeholder.svg';

type ImageSizes = 'tiny' | 'small' | 'medium' | 'large';
interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  path?: string;
  size?: ImageSizes;
  isS3?: boolean;
}

const SIZES_WIDTH = {
  tiny: 130,
  small: 200,
  medium: 300,
  large: 500
};

const SIZES_HEIGHT = {
  tiny: 78,
  small: 120,
  medium: 180,
  large: 300
};

function base64UrlEncode(input: string): string {
  return btoa(unescape(encodeURIComponent(input)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function getImageServerUrl(src, path, size: ImageSizes = 'tiny') {
  const processing = `resize:fit:${SIZES_WIDTH[size]}:${SIZES_HEIGHT[size]}`;
  const source = `local:///${path}/${src}`;
  return `${import.meta.env.VITE_IMAGESERVER}/${
    import.meta.env.VITE_IMGPROXY_SIGNATURE
  }/${processing}/${base64UrlEncode(source)}`;
}

export default function Logo({ src, path, size = 'tiny', isS3, style, onClick }: Props) {
  const maxHeightStyle = { maxHeight: `${SIZES_HEIGHT[size]}px` };

  if (isS3) {
    return (
      <img
        src={`${import.meta.env.VITE_S3_IMAGE_PROXY}/${src}`}
        className="responsive-logo"
        style={{ ...maxHeightStyle, ...style }}
        alt="logo"
        onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = ErrorLoadingImage;
        }}
      />
    );
  }

  if (!src) {
    return <img src={Placeholder} style={{ maxHeight: `${SIZES_HEIGHT[size]}px` }} alt="no logo" />;
  }
  return (
    <img
      src={getImageServerUrl(src, path, size)}
      onError={(e: any) => {
        e.target.onerror = null;
        e.target.src = Placeholder;
      }}
      style={{ maxHeight: `${SIZES_HEIGHT[size]}px` }}
      alt="company logo"
    />
  );
}
